
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","width":"1em","height":"1em","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.774 0c-.832 0-1.665.333-2.248.917l-3.204 3.25H2.497A2.506 2.506 0 000 6.667V17.5C0 18.875 1.124 20 2.497 20H13.32a2.506 2.506 0 002.498-2.5V8.667l3.247-3.25a3.171 3.171 0 000-4.5A3.314 3.314 0 0016.774 0zm-2.622 17.5a.835.835 0 01-.832.833H2.496a.835.835 0 01-.832-.833V6.667c0-.459.375-.834.832-.834h7.16L6.785 8.708C5.12 10.375 4.162 12.625 4.204 15c0 .458.375.833.832.833 2.373 0 4.62-.916 6.286-2.583l2.872-2.875V17.5h-.042zm3.704-13.25l-7.783 7.792c-1.124 1.125-2.622 1.875-4.204 2.041.208-1.583.916-3.083 2.04-4.208l7.783-7.792c.624-.583 1.582-.5 2.164.084.541.625.541 1.5 0 2.083z"}})])
          )
        }
      }
    